export default {
  // Navigation
  "home": "Home",
  "services": "Services",
  "solutions": "Solutions",
  "about": "About",
  "onlineStore": "Online Store",
  "contact": "Contact",
  
  // Hero Section
  "hero.title": "Premium Fitout &",
  "hero.titleHighlight": "Interior Solutions",
  "hero.subtitle": "Complete A to Z construction services in Saudi Arabia - Electrification, Networking, AC Systems, Digital Signage, Audio-Video Solutions & More",
  "hero.ourSolutions": "Our Solutions",
  "hero.getFreeQuote": "Get Free Quote",
  
  // Services Section
  "services.title": "Our",
  "services.titleHighlight": "Services",
  "services.subtitle": "We provide comprehensive construction and fitout services tailored to meet your specific requirements with the highest quality standards.",
  "services.electrical.title": "Electrical Systems",
  "services.electrical.description": "Complete electrical installation, maintenance, and automation systems for residential and commercial properties.",
  "services.networking.title": "Networking Solutions",
  "services.networking.description": "Advanced IT infrastructure, fiber optics, and smart connectivity solutions for modern businesses.",
  "services.hvac.title": "HVAC Systems",
  "services.hvac.description": "Energy-efficient heating, ventilation, and air conditioning systems with smart climate control.",
  "services.digitalsignage.title": "Digital Signage",
  "services.digitalsignage.description": "Interactive displays, LED screens, and digital advertising solutions for maximum impact.",
  "services.audiovisual.title": "Audio Visual",
  "services.audiovisual.description": "Professional sound systems, video conferencing, and multimedia solutions for any space.",
  "services.construction.title": "Complete Fitout",
  "services.construction.description": "End-to-end interior construction and fitout services from design to final finishing.",
  
  // Solutions Section
  "solutions.title": "Tailored",
  "solutions.titleHighlight": "Solutions",
  "solutions.subtitle": "From concept to completion, we deliver innovative solutions that transform spaces and exceed expectations.",
  "solutions.residential.title": "Residential Projects",
  "solutions.residential.description": "Luxury home automation, smart lighting, climate control, and premium interior fitout services.",
  "solutions.commercial.title": "Commercial Spaces",
  "solutions.commercial.description": "Office buildings, retail spaces, restaurants, and hospitality venues with modern infrastructure.",
  "solutions.industrial.title": "Industrial Facilities",
  "solutions.industrial.description": "Manufacturing plants, warehouses, and specialized facilities with robust electrical and mechanical systems.",
  "solutions.healthcare.title": "Healthcare Facilities",
  "solutions.healthcare.description": "Hospitals, clinics, and medical centers with specialized electrical and life safety systems.",
  
  // About Section
  "about.title": "Why Choose",
  "about.titleHighlight": "RAM?",
  "about.subtitle": "With years of experience in the Saudi Arabian market, we deliver excellence in every project we undertake.",
  "about.experience.title": "15+ Years Experience",
  "about.experience.description": "Proven track record in construction and fitout projects across Saudi Arabia.",
  "about.certified.title": "Certified Professionals",
  "about.certified.description": "Licensed engineers and technicians ensuring highest quality standards.",
  "about.support.title": "24/7 Support",
  "about.support.description": "Round-the-clock maintenance and emergency support services.",
  "about.warranty.title": "Comprehensive Warranty",
  "about.warranty.description": "Extended warranty coverage on all installations and equipment.",
  
  // Contact Section
  "contact.title": "Get In",
  "contact.titleHighlight": "Touch",
  "contact.subtitle": "Ready to transform your space? Contact us today for a free consultation and quote. Our team is here to bring your vision to life.",
  "contact.information": "Contact Information",
  "contact.phone": "Phone",
  "contact.email": "Email",
  "contact.office": "Office",
  "contact.workingHours": "Working Hours",
  "contact.workingHours.weekdays": "Sun - Thu: 8:00 AM - 6:00 PM",
  "contact.workingHours.weekend": "Fri - Sat: Emergency Only",
  "contact.findUs": "Find Us",
  "contact.form.title": "Request a Quote",
  "contact.form.name": "Full Name",
  "contact.form.email": "Email Address",
  "contact.form.phone": "Phone Number",
  "contact.form.company": "Company",
  "contact.form.service": "Service Required",
  "contact.form.message": "Project Details",
  "contact.form.namePlaceholder": "Your full name",
  "contact.form.emailPlaceholder": "your.email@almukhatat.sa",
  "contact.form.phonePlaceholder": "+966 55 642 1472",
  "contact.form.companyPlaceholder": "Your company name",
  "contact.form.messagePlaceholder": "Tell us about your project requirements, timeline, and any specific needs...",
  "contact.form.selectService": "Select a service",
  "contact.form.electrical": "Electrical Systems",
  "contact.form.networking": "Networking Solutions",
  "contact.form.hvac": "HVAC Systems",
  "contact.form.digitalSignage": "Digital Signage",
  "contact.form.audioVisual": "Audio Visual",
  "contact.form.completeFitout": "Complete Fitout",
  "contact.form.multiple": "Multiple Services",
  "contact.form.send": "Send Message",
  "contact.form.sending": "Sending...",
  "contact.form.success": "Thank you! Your message has been sent successfully. We'll get back to you within 24 hours.",
  "contact.form.error": "Please fill in all required fields correctly and ensure your message is under 500 characters.",
  "contact.form.charactersLeft": "characters",
  "contact.form.required": "*",
  
  // Footer
  "footer.description": "Leading construction and fitout company in Saudi Arabia, specializing in electrical systems, networking, HVAC, and complete interior solutions.",
  "footer.quickLinks": "Quick Links",
  "footer.services.title": "Services",
  "footer.contact.title": "Contact Info",
  "footer.contact.address": "Salman Al Farisi Road, Al Nahdah District, Al Riyadh, Kingdom of Saudi Arabia",
  "footer.followUs": "Follow Us",
  "footer.copyright": "© 2026 Almuhatat. All rights reserved.",
  
  // Common
  "learnMore": "Learn More",
  "getStarted": "Get Started",
  "readMore": "Read More",
  "viewAll": "View All"
}